import type { UserNode } from './types.graphql'

export const UserPlaceholder: UserNode = {
  id: '',
  firstName: '',
  lastName: '',
  fullName: '',
  birthNumber: '',
  address: '',
  city: '',
  postalCode: '',
  contactPersonName: '',
  contactPersonPhoneNumber: '',
  phoneNumber: '',
  initials: '',
  internalNumber: '',
  username: '',
  email: '',
  notificationEmail: '',
  isStaff: false,
  isSuperuser: false,
  isActive: false,
  needsPasswordChange: false,
  hasRegistered: false,
  activeDriverCard: undefined,
  hasActiveDriverCard: false,
  driverCards: [],
  profilePicture: '',
  position: '',
  isAdministrator: false,
  includeInSalaryCalculation: true,
  unseenNotificationCount: 0,
  mostRecentCompany: null,
  companies: [],
  allPermissions: [],
  userTypes: [
    {
      id: 'userTypeID',
      permissions: [],
      name: 'UserType',
      color: '#f00',
      isAdministrator: false,
      editable: true,
      dropdowns: [],
    },
  ],
  salaryGroups: [],
  // Prioritized salary work time for user within a module
  salaryWorkTime: null,

  documents: { edges: [], __typename: '' },
  driverFetchInfo: [],
  hasLoginCode: false,
}
